import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_IMPORT_INVOICE_PAYMENTS_ROUTE } from "../importBillPayments/importBillPayments.constants";

// const ImportBillPayments = Loadable(
//   lazy(() =>
//     import("./importBillPayments").then(({ ImportBillPayments }) => ({
//       default: ImportBillPayments,
//     }))
//   )
// );

const ImportInvoicePayments = Loadable(
  lazy(() =>
    import("./importInvoicePayment").then(({ ImportInvoicePayments }) => ({
      default: ImportInvoicePayments,
    }))
  )
);

export const ImportInvoicePaymentsRoutes = [
   
      {
        path: `${APP_FILE_IMPORT_INVOICE_PAYMENTS_ROUTE}/:type`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[]} allowFullAccess>
            <ImportInvoicePayments />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_IMPORT_INVOICE_PAYMENTS_ROUTE}/:type`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[]} allowFullAccess>
            <ImportInvoicePayments />
          </AuthorizedRoute>
        ),
      },
];
